import Button from "./Button"
import { Link } from 'react-router-dom'
import HeaderIMG from '../assets/Header.png'
import Modal from "./Modal"
import { useEffect } from "react"
import { getLeaderBoard } from './Firebase';
import { useState } from "react"
import Leaderboard from "./Leaderboard"


const MainMenu = () => {
    const [leaderBoard, setLeaderBoard] = useState([])  



    function CreateLeaderBoard(){
        getLeaderBoard().then(res => {
            console.log(res)
            setLeaderBoard(res)
            var d = new Date()
            var obj = {leaderboard: res, date: d }
            console.log('SETTING LOCALSTORAGE')
            localStorage.setItem('Leaderboard',  JSON.stringify(obj))
        })
    }

    function FetchLeaderBoard(){
        if (localStorage.getItem('Leaderboard') === null ){
            CreateLeaderBoard()
        }
        else {
            var now = new Date()
            var OBJ = JSON.parse(localStorage.getItem('Leaderboard'))
            var then = Date.parse(OBJ.date)
            console.log((diff_minutes(now, then) > 5))
            if(diff_minutes(now, then) > 5){
                CreateLeaderBoard()
                console.log('NEW LEADERBOARD')
            }else {
                setLeaderBoard(OBJ.leaderboard)
                console.log('OLD LEADERBOARD')
            }
        }
    }

    function diff_minutes(dt2, dt1){
        var diff =(dt2.getTime() - dt1) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }
    return (
        <div className="main-view" >
            <Modal header={"Leaderboard"} realleaderboard={leaderBoard}></Modal>
            {/* <Header title="" backgroundImg={HeaderIMG}></Header> */}
            <div style={{marginTop:'2.5rem', display:'flex', justifyContent:'center'}}>
                <img src={HeaderIMG} alt="" style={{width:'40vw', height:'auto'}}/>
            </div>
            <div className='btn-group'>
                <Link to='/Solo' style={{width:'fit-content'}}><Button text="SOLO"></Button></Link>
                <Link to='/multiplayer'><Button text="MULTIPLAYER"></Button></Link>
                <Button onClick={() => {document.getElementById("Leaderboard").style.display = "block"; FetchLeaderBoard()}} text="LEADERBOARD"></Button>
            </div>
        </div>
    )
    

}

export default MainMenu
